import React from "react";
import styles from "./styles.css";
import newSticker from "./images/new.png";
import { CLP_CRM_VARIANTS } from "../car-list-revamp/helper";
import { PropTypes } from "prop-types";

const ClpNewArrivalBanner = ({
    clpCrmVariantConfig,
    totalCars
}) => {

    const configData = clpCrmVariantConfig?.[CLP_CRM_VARIANTS.NEW_ARRIVAL] || {};

    return (
        <div styleName={"styles.outer"}>
            <img src={configData?.imageUrl} alt="banner-image" />
            <p styleName={"styles.heading"}>{configData?.title}</p>
            <p styleName={"styles.subHeading"}>{configData?.subtitle}</p>
            <p styleName={"styles.newCarsAdded"}><img src={newSticker} />{totalCars} new cars added</p>
        </div>
    );
};

ClpNewArrivalBanner.propTypes = {
    clpCrmVariantConfig: PropTypes.object,
    totalCars: PropTypes.number
};

export default ClpNewArrivalBanner;
